import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ANALYTICS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Analytics = lazy(() =>
  import('../../../screens/Analytics')
    .then(module => ({default: module.Analytics})));

const AnalyticsNavigation = [
  {
    path: ROUTE_ANALYTICS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Analytics />
      </Suspense>
    ),
  },
];

export default AnalyticsNavigation;
